import React from 'react';

// Icon colors come from the Tailwind palette (tailwind.config.js) via fill-* utilities:
// bright-blue (debug), status-green (info), warning-dark-yellow (warning), orange (error).
export const LOG_LEVEL_ICONS: Record<string, React.ReactNode> = {
  '10': (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" className="fill-blue-1" />
      <g transform="translate(3, 3)">
        <path
          d="M10 4H8.595C8.37 3.61 8.06 3.275 7.685 3.02L8.5 2.205L7.795 1.5L6.71 2.585C6.48 2.53 6.245 2.5 6 2.5C5.755 2.5 5.52 2.53 5.295 2.585L4.205 1.5L3.5 2.205L4.31 3.02C3.94 3.275 3.63 3.61 3.405 4H2V5H3.045C3.02 5.165 3 5.33 3 5.5V6H2V7H3V7.5C3 7.67 3.02 7.835 3.045 8H2V9H3.405C3.925 9.895 4.89 10.5 6 10.5C7.11 10.5 8.075 9.895 8.595 9H10V8H8.955C8.98 7.835 9 7.67 9 7.5V7H10V6H9V5.5C9 5.33 8.98 5.165 8.955 5H10V4ZM8 7.5C8 7.61 7.985 7.735 7.965 7.85L7.915 8.175L7.73 8.5C7.37 9.12 6.71 9.5 6 9.5C5.29 9.5 4.63 9.115 4.27 8.5L4.085 8.18L4.035 7.855C4.015 7.74 4 7.615 4 7.5V5.5C4 5.385 4.015 5.26 4.035 5.15L4.085 4.825L4.27 4.5C4.42 4.24 4.63 4.015 4.875 3.845L5.16 3.65L5.53 3.56C5.685 3.52 5.845 3.5 6 3.5C6.16 3.5 6.315 3.52 6.475 3.56L6.815 3.64L7.12 3.85C7.37 4.02 7.575 4.24 7.725 4.505L7.915 4.83L7.965 5.155C7.985 5.265 8 5.39 8 5.5V7.5ZM5 7H7V8H5V7ZM5 5H7V6H5V5Z"
          className="fill-white"
        />
      </g>
    </svg>
  ),
  '20': (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" className="fill-white" />
      <path
        d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8.8 12H7.2V7.2H8.8V12ZM8.8 5.6H7.2V4H8.8V5.6Z"
        className="fill-ui-cta-primary"
      />
    </svg>
  ),
  '30': (
    <svg
      width="18"
      height="18"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 1.25L0.5 10.75H11.5L6 1.25Z" className="fill-yellow-1" />
      <path d="M6.5 5.25H5.5V7.25H6.5V5.25Z" className="fill-white" />
      <path d="M6.5 8.25H5.5V9.25H6.5V8.25Z" className="fill-white" />
    </svg>
  ),
  '40': (
    <svg
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.98597 12.2397C8.28988 12.2397 8.53897 12.1473 8.73325 11.9623C8.92754 11.7774 9.02468 11.533 9.02468 11.2291C9.02468 10.9252 8.92908 10.6729 8.73788 10.4724C8.54667 10.2718 8.29912 10.1716 7.99522 10.1716C7.69132 10.1716 7.44222 10.2717 7.24794 10.472C7.05366 10.6724 6.95652 10.9245 6.95652 11.2284C6.95652 11.5323 7.05212 11.7768 7.24332 11.962C7.43453 12.1471 7.68208 12.2397 7.98597 12.2397ZM7.16334 8.91187H8.93067V3.83549H7.16334V8.91187ZM7.99819 16C6.88425 16 5.84312 15.7927 4.87481 15.378C3.90649 14.9633 3.05928 14.3929 2.33318 13.6668C1.60708 12.9407 1.0367 12.0939 0.622026 11.1264C0.207342 10.1589 0 9.11759 0 8.00259C0 6.88758 0.207342 5.84545 0.622026 4.8762C1.0367 3.90695 1.6061 3.06209 2.33023 2.3416C3.05436 1.62111 3.90065 1.05072 4.8691 0.63043C5.83753 0.210143 6.87978 0 7.99584 0C9.1119 0 10.1553 0.209661 11.126 0.628982C12.0967 1.04829 12.9419 1.61736 13.6614 2.33619C14.381 3.05502 14.9506 3.90031 15.3704 4.87207C15.7901 5.84381 16 6.88792 16 8.0044C16 9.12008 15.7899 10.162 15.3696 11.1301C14.9493 12.0982 14.3789 12.9434 13.6584 13.6656C12.9379 14.3879 12.0929 14.9575 11.1234 15.3745C10.1539 15.7915 9.11214 16 7.99819 16Z"
        className="fill-unlisted-orange"
      />
    </svg>
  ),
};

const LOG_LEVEL_LABELS: Record<number, string> = {
  10: 'Debug',
  20: 'Info',
  30: 'Warning',
  40: 'Error',
};

export function getLogLevelIcon(level: number): React.ReactNode {
  return LOG_LEVEL_ICONS[String(level)] ?? null;
}

export function getLogLevelLabel(level: number): string {
  return LOG_LEVEL_LABELS[level] ?? '--';
}
